import visitorNames from '../../data/visitorNames.json';
import type { components } from '../multiplayer/api.generated';
import type { Clothing } from './visitorAppearance';

export class CitizenSelection {
  character: 'male' | 'female' = 'male';
  colour: Clothing = 'russet';
  private readonly chosen = { male: visitorNames.male[0], female: visitorNames.female[0] };

  get names(): readonly string[] {
    return visitorNames[this.character];
  }

  get name(): components['schemas']['NameEnum'] {
    return this.chosen[this.character] as components['schemas']['NameEnum'];
  }

  chooseName(name: string): void {
    if (!this.names.includes(name)) throw new Error('Name is not in this citizen register');
    this.chosen[this.character] = name;
  }

  rollName(random = Math.random()): void {
    const alternatives = this.names.filter((name) => name !== this.name);
    const name = alternatives[Math.floor(random * alternatives.length)];
    if (!name) throw new Error('Invalid citizen register dice roll');
    this.chooseName(name);
  }
}
